import { message } from 'antd';

import Utils from '../../../Assets/Scripts/Utils';
import { api } from '../../../Services/axiosService';

function pickList(data, camelKey, pascalKey) {
  const value = data?.[camelKey] ?? data?.[pascalKey];
  return Array.isArray(value) ? value : [];
}

export const fetchManagementList = async (filters) => {
  try {
    const response = await api.post('/Occurrence/ManagementList', filters);
    return response.data ?? [];
  } catch (error) {
    Utils.logError(error);
    message.error('Oops. Algo deu errado ao tentar buscar as ocorrências!');
    return [];
  }
};

export const fetchManagementFilterOptions = async () => {
  try {
    const response = await api.get('/Occurrence/ManagementFilterOptions');
    const data = response.data ?? {};
    return {
      types: pickList(data, 'types', 'Types'),
      occurrences: pickList(data, 'occurrences', 'Occurrences'),
      dealIds: pickList(data, 'dealIds', 'DealIds'),
      cardTitles: pickList(data, 'cardTitles', 'CardTitles'),
      dealClients: pickList(data, 'dealClients', 'DealClients'),
    };
  } catch (error) {
    Utils.logError(error);
    message.error('Oops. Algo deu errado ao tentar buscar as opções de filtro!');
    return { types: [], occurrences: [], dealIds: [], cardTitles: [], dealClients: [] };
  }
};
